/**
 * Moduł obsługujący gwarancje abonamentowe zakupione w SI
 */
app.service('orderSubscriptionWarranties', function (modal, loading) {

	function init() {
		setEvents();
	}

	function setEvents() {
		$('body').on('click', '.js-subscribe-card', function () {
			UA.interaction('KME', 'Abonament', 'Aktywuj ochrone sprzetu')
			const orderNumber = $(this).attr('data-order-number');
			subscribeCard(orderNumber);
		});
	}

	function loadOrderSubscriptionWarranties() {
		return $.ajax({
			method: 'GET',
			url: '/customer-account-orders-with-card-subscription-available.ltr'
		}).fail(onError);
	}

	function subscribeCard(orderNumber) {
		loading.start();
		$.ajax({
			method: 'POST',
			url: '/card-subscription-transaction-payment-url.ltr',
			data: {
				orderNumber
			}
		}).then(response => {
			if (response.status === 'FAIL') {
				loading.stop();
				modal.alert(response.messages.join(''));
			} else {
				loading.redirect(response.transactionPaymentUrl);
			}
		}).fail(() => {
			loading.stop();
			modal.alert("Wystąpiły problemy techniczne. Spróbuj dodać kartę jeszcze raz lub skontaktuj się z działem pomocy.");
		});
	}

	function onError() {
		modal.alert("Błąd ładowania listy gwarancji. Odśwież stronę lub skontaktuj się z działem pomocy.");
	}

	return {
		init,
		loadOrderSubscriptionWarranties
	};
});
